import React from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

function GoBack({path}) {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(`${path}`);
  };

  return (
    <div className="flex items-center gap-1 hover:cursor-pointer w-[70px]" onClick={() => goBack()}>
      <AiOutlineArrowLeft />
      <span>Voltar</span>
    </div>
  );
}

export default GoBack;
